import type { IInterestListFiltersProps } from '@on3/ui-lib/api/schema/custom-contracts';
import { addAllToList } from '@on3/ui-lib/utils/addAllToList';
import clsx from 'clsx';
import {
  type ILinkFilterItem,
  LinkFilter,
} from 'components/Db/Filters/LinkFilter';
import { useRouter } from 'next/router';
import { useSortedConferences } from 'utils/hooks/useSortedConferences';

import { Filter, makeList } from '../../../Db/Filters/Filter';
import FilterTeams from '../../../Db/Filters/FilterTeams';
import styles from './InterestListFilters.module.scss';

const interestRoutes: ILinkFilterItem[] = [
  {
    key: 1,
    name: 'commits',
    pathname: '/college/[college]/[sport]/[year]/industry-comparison-commits',
  },
  {
    key: 2,
    name: 'decommits',
    pathname: '/college/[college]/[sport]/[year]/industry-comparison-decommits',
  },
  {
    key: 3,
    name: 'visits',
    pathname: '/college/[college]/[sport]/[year]/visits',
  },
  {
    key: 4,
    name: 'offers',
    pathname: '/college/[college]/[sport]/[year]/offers',
  },
];

const commitDecommitRoutes: ILinkFilterItem[] = [
  {
    key: 1,
    name: 'commits',
    pathname: '/recruiting/latest-commits',
  },
  {
    key: 2,
    name: 'decommits',
    pathname: '/recruiting/latest-decommits',
  },
];

export const InterestListFilters = ({
  years,
  sports,
  status,
  teams,
  className,
  selectedInterest,
}: IInterestListFiltersProps) => {
  const sortedConferences = useSortedConferences(teams);
  const router = useRouter();
  const currentYear = new Date().getFullYear();
  const isLatestCommitsPage = router.asPath.includes('latest-commits');
  const isLatestDecommitsPage = router.asPath.includes('latest-decommits');
  const { year, sport = 'All' } = router.query;
  const sportsList =
    isLatestCommitsPage || isLatestDecommitsPage
      ? addAllToList(sports)
      : sports;
  const onlyYearsList = years && makeList(years);
  const yearsList =
    (isLatestCommitsPage || isLatestDecommitsPage) && years
      ? addAllToList(onlyYearsList)
      : onlyYearsList;
  const selectedYear = !year ? 'All' : year ? year : currentYear;
  const selectedSport = !sport ? 'All' : sport;
  const displayStatusRoute =
    isLatestCommitsPage || isLatestDecommitsPage
      ? commitDecommitRoutes
      : interestRoutes;

  return (
    <div className={clsx(styles.filterWrapper, className)}>
      {teams && <FilterTeams name="college" teams={sortedConferences} />}
      {years && (
        <Filter list={yearsList} name="year" selected={`${selectedYear}`} />
      )}
      {sports && (
        <Filter list={sportsList} name="sport" selected={`${selectedSport}`} />
      )}
      {status && selectedInterest && (
        <LinkFilter
          selected={selectedInterest}
          sportList={displayStatusRoute}
        />
      )}
    </div>
  );
};
